import './App.css';
import NavbarN from './Componant/NavbarN/NavbarN';
import Home from './Componant/Home/Home';
import Home1 from './Componant/Home1/Home1';
import Home2 from './Componant/Home2/Home2';
import Page4 from './Componant/Page4/Page4';
import Page5 from './Componant/Page5/Page5';
import Page6 from './Componant/page6/page6';
import Footer from './Componant/Footer/Footer';

function App() {
  return (
   <div>
    <NavbarN />
    <Home />
    <Home1 />
    <Home2 />
    <Page4 />
    <Page5 />
    <Page6 />
    <Footer />
   </div>
  );
}

export default App;
